import { Box, Grid2, Typography } from '@mui/material';
import moment from 'moment';
import React from 'react';
import { Rating } from 'react-simple-star-rating'
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Constant from '../../../../../Utils/Constant';
import NoDataImg from '../../../../../Components/NoDataFound/NoDataFound';
import Skeleton from 'react-loading-skeleton';
const UserReview = (props) => {
    const { userReviewList, isLoading } = props;
    return (
        <Box sx={{
            width: '100%',
            padding: '0px 10px 0px 10px',
            height:'calc(100vh - 210px)',
            overflowY:'auto',
        }}>
            <Grid2 container spacing={2} height={
                userReviewList && userReviewList?.length > 0 ? "auto" : "100%"
            }>
                {isLoading ? (
                    <>
                        {[...Array(1)].map((_, index) => (
                            <Grid2 size={{ xs: 12, xl: 6, }} key={index}>
                                <Skeleton variant="circle" height={100} borderRadius={15}/>
                            </Grid2>

                        ))}
                    </>
                ) : userReviewList?.length > 0 ? userReviewList?.map((elem, index) => {
                    return (
                        <Grid2 key={index} size={{ xs: 12, xl: 6 }}>
                            <Box sx={{
                                width: '100%',
                                background: "#FAFAFA",
                                border: "1px solid #08557F33",
                                padding: '15px',
                                borderRadius: '15px',
                                width: '100%',

                            }}>
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    gap: 1,
                                }}>
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                    }}>
                                        {elem?.profile_img ? <img
                                            src={`${Constant.BASE_URL}${elem?.profile_img}`}
                                            alt="interpreter_Profile"
                                            style={{
                                                width: "40px",
                                                height: "40px",
                                                objectFit: "cover",
                                                borderRadius: "50%",
                                                objectPosition: "top",
                                            }}
                                        /> : <AccountCircleIcon sx={{ fontSize: "40px" }} />}
                                        <Box sx={{}}>
                                            <Typography
                                                sx={{
                                                    fontSize: "16px",
                                                    fontWeight: "300",
                                                    color: "rgba(40, 29, 27, 1)",
                                                    textAlign: "left",
                                                    width: "100%",
                                                    fontFamily: "Outfit",
                                                    fontWeight: '600'
                                                }}
                                            >
                                                {elem?.full_name || "-"}
                                            </Typography>
                                            <Rating
                                                // rating={elem?.rating}
                                                initialValue={elem?.rating}
                                                size={20}
                                                activeColor="blue"
                                                inactiveColor="gray"
                                                readonly={true}
                                            />
                                        </Box>
                                    </Box>
                                    <Typography
                                        sx={{
                                            fontSize: "14px",
                                            fontWeight: "300",
                                            color: "rgba(0, 0, 0, 0.6)",
                                            textAlign: "center",
                                            fontFamily: "Outfit"
                                        }}
                                    >
                                        {moment(elem?.created_at).fromNow() || "Just now"}
                                    </Typography>
                                </Box>
                                <Typography
                                    sx={{
                                        fontSize: "14px",
                                        fontWeight: "300",
                                        color: "rgba(0, 0, 0, 0.8)",
                                        width: "100%",
                                        fontFamily: "Outfit",
                                        padding: '10px 10px'
                                    }}
                                >
                                    {elem?.review || '-'}
                                </Typography>
                            </Box>
                        </Grid2>
                    )
                })
                    : <Grid2 size={{ xs: 12 }}
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                        }}>
                        <NoDataImg />
                    </Grid2>}
            </Grid2>

        </Box>
    );
};

export default UserReview;